/**
 * 请求封装
 * 创建实例，请求拦截，响应拦截
 */

import axios from 'axios';
import qs from 'qs';
import global_ from '@/components/Global';
// import router from '@/router';

const instance = axios.create({
    // 基本 url
    baseURL: global_.serversrc,
    // 10 秒超时，也可以自定义
    timeout: 20000,
    // 只能用在put post patch这几个请求方法
    transformRequest: [
        (data) => {
            // 对发送的 data 进行任意转换处理
            if (data) {
                // 对参数进行处理
                Object.keys(data).forEach((key) => {
                    // 获取当前项目值
                    const value = data[key];
                    // 对数组进行转换
                    if (Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]')
                        // 对json数据进行处理
                        data[key] = JSON.stringify(value);
                });

                return qs.stringify(data);
            }
            return data;
        },
    ],
});

/**
 * 请求拦截
 * 发送请求前添加一些额外的参数
 * hCode：医院编码
 */
instance.interceptors.request.use(
    (config) => {
        // 添加token
        // 添加参数
        if (config.method === 'post') {
            // 请求头
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        // 添加医院参数
        config.params = {
            ...config.params,
            _t: Date.parse(new Date()),
        };
        return config;
    },
    (error) => {
        //
        return Promise.reject(error);
    }
);

/**
 * 响应的拦截器
 */
instance.interceptors.response.use(
    (response) => {
        // console.log(response);
        // 2xx 范围内的状态码都会触发该函数。
        // 统一的错误处理，这里的错误是指后台返回的业务错误，并不是请求错误
        const res = response.data;
        // api 接口返回的数据结构应该为 { success: <boolean>, msg: <string>, data: <object> }
        if (res) {
            if (typeof res.success === 'boolean' && res.success === false) {
                // 后台需要定义错误类型，完成异常捕获
                // 显示错误信息
                // 抛出异常
                return Promise.reject(response.data);
            }
        }
        return res;
    },
    (error) => {
        // 取消全局loading
        // 存在错误信息
        if (error.response) {
            // 进行错误码区分
            switch (error.response.status) {
                // 认证失败
                case 401:
                    // 登录页面
                    window.location = '/';
                    break;
                // 未找到
                case 404:
                    break;
                // 服务端拒绝请求
                case 403:
                    break;

                // 内部错误
                case 500:
                    break;
                // 默认
                default:
                    break;
            }
        } else {
            // 处理超时的情况
            // const { config } = error;
            // // 重试次数--未配置
            // if (!config || !config.retry) return Promise.reject(error);
            // TODO 后续考虑是否添加重试次数
        }

        // 超出 2xx 范围的状态码都会触发该函数。
        return Promise.reject(error);
    }
);

export default instance;
